import * as React from 'react';

import { OffersPicker } from '../../components/OffersPicker';
import { useObserver } from '../../hooks/useObserver';
import { useVirtualList } from '../../hooks/useVirtualList';
import { IOfferSchema } from '../../repositories/chats/entities/get_my_offers_for_selection/OfferSchema';
import { ERequestApiStatus } from '../../types/appState';

// для удаления неотображаемых элементов из dom фиксируем высоту одной объявки
const ROW_HEIGHT = 97;

interface IProps {
  currentType: string;
  isReachedLimit: boolean;
  selectedIds: Array<number>;
  offersList: IOfferSchema[];
  offersSelectionStatus: ERequestApiStatus;
  handleOffersLoad: () => void;
  onSelect(value: IOfferSchema): void;
  handleTypeChange(_: never, value: string): void;
}

export const OffersPickerContainer = ({
  currentType,
  selectedIds,
  offersList,
  offersSelectionStatus,
  isReachedLimit,
  onSelect,
  handleOffersLoad,
  handleTypeChange,
}: IProps) => {
  const pickerAreaRef = React.useRef<HTMLDivElement>(null);
  const targetObserverElementRef = React.useRef<HTMLDivElement>(null);

  const { handleSlicedList, upperEmptyBlockHeight, downEmptyBlockHeight, startIndex, endIndex } = useVirtualList({
    scrollAreaRef: pickerAreaRef,
    rowHeight: ROW_HEIGHT,
    list: offersList,
  });

  useObserver({
    rootElementRef: pickerAreaRef,
    targetElementRef: targetObserverElementRef,
    handler: handleOffersLoad,
  });

  React.useEffect(() => {
    handleSlicedList();
  }, [offersList, handleSlicedList]);

  return (
    <OffersPicker
      handleOffersLoad={handleOffersLoad}
      pickerAreaRef={pickerAreaRef}
      targetObserverElementRef={targetObserverElementRef}
      offersSelectionStatus={offersSelectionStatus}
      offersList={offersList}
      handleSlicedList={handleSlicedList}
      upperEmptyBlockHeight={upperEmptyBlockHeight}
      currentType={currentType}
      selectedIds={selectedIds}
      isReachedLimit={isReachedLimit}
      onSelect={onSelect}
      handleTypeChange={handleTypeChange}
      downEmptyBlockHeight={downEmptyBlockHeight}
      startIndex={startIndex}
      endIndex={endIndex}
    />
  );
};
